<template>
  <v-dialog
    v-model="dialogVisible"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    persistent
    class="d-flex flex-column"
  >
    <v-card tile class="d-flex flex-column" style="height: 100vh">
      <div
        id="titulo-dialog"
        class="df pa-4 d-flex align-center"
        style="
          flex-shrink: 0;
          position: relative;
          z-index: 5;
          background: #071a2a;
        "
      >
        <v-btn icon dark @click="handleClose()" class="me-4">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <img :src="logo" alt="webcotacao" class="h-35px" />
      </div>

      <!-- Breadcrumb -->
      <div
        class="px-6 py-2"
        style="
          flex-shrink: 0;
          background: white;
          position: relative;
          z-index: 4;
        "
      >
        <div class="d-flex align-center" style="font-size: 14px">
          <span
            class="mr-1"
            style="cursor: default; text-decoration: none; color: #424242"
            >Carrinho de Compras</span
          >
          <span class="mx-1" style="color: #9e9e9e">></span>
          <span
            class="mr-1"
            style="cursor: default; text-decoration: none; color: #424242"
            >Cotação</span
          >
          <span class="mx-1" style="color: #9e9e9e">></span>
          <span
            class="mr-1"
            style="cursor: default; text-decoration: none; color: #424242"
            >Nova Cotação</span
          >
          <span class="mx-1" style="color: #9e9e9e">></span>
          <span
            class="mr-1"
            style="cursor: default; text-decoration: none; color: #424242"
            >{{ cotacaoTitulo || "[Título da cotação]" }}</span
          >
          <span class="mx-1" style="color: #9e9e9e">></span>
          <span
            class="px-2 py-1"
            style="
              background: #ecf1ff;
              border-radius: 4px;
              color: #1976d2;
              font-weight: 500;
            "
            >Visualizar fornecedores</span
          >
        </div>
      </div>

      <!-- Título com seta de voltar e campo de busca + botões -->
      <div
        class="px-6 py-4"
        style="
          flex-shrink: 0;
          background: white;
          position: relative;
          z-index: 3;
        "
      >
        <div class="d-flex align-center justify-space-between mb-3">
          <!-- Título com seta de voltar -->
          <div class="d-flex align-center">
            <v-btn icon @click="handleClose()" class="mr-2">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <h2 class="font-weight-medium mb-0" style="font-size: 18px">
              Fornecedores da cotação
            </h2>
          </div>

          <!-- Botões de ação à direita -->
          <div>
            <v-btn
              class="wc-btn-actions"
              color="red"
              text
              @click="handleLimparLista"
              :disabled="isLimpandoLista || fornecedoresFiltrados.length === 0"
            >
              {{
                selected.length > 0 ? "Excluir selecionados" : "Limpar lista"
              }}
            </v-btn>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mx-2 wc-btn-actions"
                  color="primary"
                  outlined
                  @click="handleRevisarContatos"
                >
                  Revisar contatos
                </v-btn>
              </template>
              <span>Adicione e selecione contatos para representar os fornecedores que não possuem contatos selecionados.</span>
            </v-tooltip>
            <v-btn
              class="wc-btn-actions"
              color="primary"
              @click="handleAbrirAdicionarFornecedores"
            >
              Adicionar fornecedores via Systock
            </v-btn>
          </div>
        </div>

        <!-- Campo de busca à esquerda -->
        <div>
          <v-text-field
            v-model="searchQuery"
            placeholder="Buscar por CNPJ, Razão Social ou Nome Fantasia"
            outlined
            dense
            prepend-inner-icon="mdi-magnify"
            clearable
            hide-details
            style="max-width: 500px"
          ></v-text-field>
        </div>
      </div>

      <div class="content-body flex-grow-1 overflow-y-auto px-4">
        <div v-if="fornecedoresFiltrados.length > 0">
          <sys-data-table
            ref="dataTable"
            class="wc-table-fixed-column"
            :headers="headers"
            :items="fornecedoresFiltrados"
            item-key="_itemId"
            v-model="selected"
            show-select
            :height="alturaTabela"
            item-height="50"
            :loading="isLoading"
          >
            <template v-slot:[`item.cnpj`]="{ item }">
              {{ formatCNPJ(item.cnpj) }}
            </template>

            <template v-slot:header.contatos="{ text }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-on="on" v-bind="attrs" v-text="text" />
                </template>
                <span>Contatos selecionados para receber o convite e preencher em nome do fornecedor</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.contatos`]="{ item }">
              <div
                class="d-flex align-center wc-link"
                @click="handleVisualizarContatos(item)"
              >
                <v-icon
                  small
                  class="mr-2 wc-contato-icon"
                  :class="{
                    'wc-contato-icon-empty': item.contatos === 0,
                    'wc-contato-icon-filled': item.contatos > 0,
                  }"
                  :color="item.contatos > 0 ? '#4075ff' : '#C81E1E'"
                >
                  {{
                    item.contatos > 0
                      ? "mdi-account-outline"
                      : "mdi-account-plus-outline"
                  }}
                </v-icon>
                <span v-if="item.contatos > 0">
                  {{ item.contatos }}
                  {{ item.contatos === 1 ? "contato" : "contatos" }}
                </span>
                <span v-else> Adicionar contato </span>
              </div>
            </template>

            <!-- ações -->
            <template v-slot:[`item.acoes`]="{ item }">
              <div>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-on="on" v-bind="attrs" @click.stop="handleExcluir(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Excluir fornecedor</span>
                </v-tooltip>
              </div>
            </template>
          </sys-data-table>

          <!-- Loading indicator para scroll infinito -->
          <div v-if="isLoadingMore" class="text-center py-4">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <p class="mt-2">Carregando mais fornecedores...</p>
          </div>

          <!-- Elemento sentinela para IntersectionObserver -->
          <div ref="scrollSentinel" style="height: 1px; width: 100%"></div>
        </div>

        <div v-else class="wc-empty-state">
          <v-icon large color="#c2c9d6" class="mb-4" style="font-size: 56px"
            >mdi-truck-delivery-outline</v-icon
          >
          <p class="wc-empty-title">Não há fornecedores adicionados</p>
          <p class="wc-empty-subtitle">
            Adicione novos fornecedores via Systock Inteligência de Estoque para
            a nova cotação
          </p>
        </div>
      </div>
    </v-card>

    <VisualizarFornecedoresDialog
      :visible="openAdicionarFornecedores"
      :id-cotacao="props.idCotacao"
      :handleClose="handleFecharAdicionarFornecedores"
      @fornecedores-adicionados="handleFornecedoresAdicionados"
    />
    <RevisarContatosDialog
      :visible="contatosDialogVisible"
      :fornecedores="fornecedoresParaContatos"
      :initial-index="indiceFornecedorContato"
      :handle-close="handleCloseContatosDialog"
      :mostrar-filtro-sem-contato="mostrarFiltroSemContato"
      :id-cotacao="props.idCotacao"
      @salvar="handleSalvarContatos"
      @salvar-contato="handleSalvarContatoAtualizado"
      @excluir-contato="handleExcluirContato"
      @criar-contato="handleCriarContato"
    />
  </v-dialog>
</template>

<script setup>
import logo from "@/assets/logo_header.png";
import RevisarContatosDialog from "@/components/webcotacao/components/RevisarContatosDialog.vue";
import VisualizarFornecedoresDialog from "@/components/webcotacao/components/VisualizarFornecedoresDialog.vue";
import useVisualizarFornecedoresCotacaoDialog from "@/components/webcotacao/composables/useVisualizarFornecedoresCotacaoDialog";
import { ref, watch, defineProps, defineEmits } from "vue";

const props = defineProps({
  visible: { type: Boolean },
  idCotacao: { type: Number },
  handleClose: { type: Function },
});

const emit = defineEmits(["update:fornecedores"]);

const {
  isLoading,
  isLoadingMore,
  fornecedores,
  selected,
  headers,
  alturaTabela,
  cotacaoTitulo,
  searchQuery,
  fornecedoresFiltrados,
  formatCNPJ,
  isLimpandoLista,
  dataTable,
  scrollSentinel,
  resetScrollPosition,
  contatosDialogVisible,
  fornecedoresParaContatos,
  indiceFornecedorContato,
  mostrarFiltroSemContato,
  handleCloseContatosDialog,
  handleSalvarContatos,
  handleVisualizarContatos,
  handleRevisarContatos,
  handleSalvarContatoAtualizado,
  handleCriarContato,
  handleExcluirContato,
  openAdicionarFornecedores,
  handleAbrirAdicionarFornecedores,
  handleFecharAdicionarFornecedores,
  handleFornecedoresAdicionados,
  handleExcluir,
  handleLimparLista,
} = useVisualizarFornecedoresCotacaoDialog(props);

watch(
  fornecedores,
  (newVal) => {
    emit("update:fornecedores", newVal);
  },
  { deep: true }
);

const dialogVisible = ref(false);

if (props.visible) {
  dialogVisible.value = props.visible;
}

watch(
  () => props.visible,
  (newValue) => {
    if (dialogVisible.value !== newValue) {
      dialogVisible.value = newValue;
      if (newValue) {
        resetScrollPosition();
      }
    }
  },
  { immediate: true }
);

watch(dialogVisible, (newValue, oldValue) => {
  if (!newValue && oldValue && props.handleClose) {
    props.handleClose();
  }
});

const handleClose = () => {
  resetScrollPosition();
  dialogVisible.value = false;
  if (props.handleClose) {
    props.handleClose();
  }
};
</script>

<style scoped></style>

